import { successAuth } from "../logic/login/reducer";

const checkAuthorization= (dispatch) =>{
    const storedToken = localStorage.getItem("token");
    const user = localStorage.getItem("user");
    // const storedToken = cookie.load("token");
  
    if (storedToken) {
        dispatch(successAuth({token:storedToken,user:user?JSON.parse(user):{}}));
      return true;
    }
  
    return false;
  }


export function checkWidgetAuthorization({ state, dispatch }) {
    const token = state?.token;
    console.log(token);
    if (token) return true;
    return checkAuthorization(dispatch);
}